import { useEffect, useMemo } from "react";
import TaskHeaderCard from "../../../../components/AssetManagement/Health/DataAccuracy/TaskNameDataAccuracy/TaskHeaderCard";
import { useSelector } from "react-redux";
import { filterAndGroupTasks } from "../../../../components/AssetManagement/Health/DataAccuracy/DataAccuracyHelpers/helpers";
import {
  selectUserData,
  selectUserToken,
} from "../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTasksByTaskStructureSharedUidLoader } from "../../../../features/dataAccuracySlice";
import { DataAccuracyEndPointLogic } from "../../../../logic/AssetManagement/Health/Data Accuracy/dataAccuracyEndPointLogic";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import DataAccuracyFullSkeleton from "./DataAccuracyFullSkeleton";
import OccurrencesTable from "./OccurrencesTable";

export const OccurrencesDataAccruracyScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { tasksByTaskStructureSharedUid, dataAccruracyData } = useSelector(
    (state: any) => state.dataAccuracy
  );
  const taskStructureSharedUid = searchParams.get("task_structure_shared_uid");

  const filterdTaskDetails = filterAndGroupTasks(
    dataAccruracyData?.query_output,
    taskStructureSharedUid
  );

  const firstTask = filterdTaskDetails?.[0] || {};
  const referanceId = searchParams.get("reference_id");

  const filteredTasksByTaskStructureSharedUid = useMemo(
    () =>
      (tasksByTaskStructureSharedUid ?? []).filter(
        (task: any) => task.reference_id === referanceId
      ),
    [tasksByTaskStructureSharedUid, referanceId]
  );

  const {
    title = "",
    websites = [],
    category = "",

    priority = "",
    description = "",
  } = firstTask;

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("taskTitle", title);
    setSearchParams(newParams);
  }, [title, setSearchParams, searchParams]);
  const { tasksByTaskStructureSharedUidLoader, isSuccess, allDimensions } =
    useSelector((state: any) => state.dataAccuracy);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const token = useSelector(selectUserToken);
  const assetSharedUid = searchParams.get("asset_shared_uids")?.split(",");
  const queryId = "5637377896742912";
  const fetchBy = searchParams.get("fetchBy") || "Website";
  const type = fetchBy === "Website" ? "site" : "dimension";
  const selectedSites = searchParams.get("selected")?.split(",");
  const siteAndDimensionsList = useSelector(selectUserData);
  const siteList = siteAndDimensionsList?.data?.website_permissions;

  const userPermittedOrganizationName =
    siteAndDimensionsList?.data?.user_details?.organization_name;
  const allDimenssionList = allDimensions.filter(
    (dimension: any) =>
      dimension.organization_id__organization_name ===
      userPermittedOrganizationName
  );

  const filteredDimensionList = allDimenssionList.map((dimension: any) => {
    return dimension.dimension;
  });
  const dimensionList = siteAndDimensionsList?.data?.dimensions;
  const hasEditDataAnomalyPermission = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "edit_data_anomaly"
  );

  useEffect(() => {
    const fetchDataAccuracy = async () => {
      dispatch(setTasksByTaskStructureSharedUidLoader(true));
      try {
        await DataAccuracyEndPointLogic.getTasksByTaskStructureSharedUid(
          token,
          taskStructureSharedUid ?? "",
          assetSharedUid,
          dispatch
        );
        await DataAccuracyEndPointLogic.getDataAccuracyByWebsiteOrDimensionOrOrganization(
          queryId,
          token,
          type,
          type === "site" ? selectedSites : [Object.keys(siteList[0])[0]],
          fetchBy === "Dimension"
            ? selectedSites
            : fetchBy === "Organization"
            ? filteredDimensionList // Send all dimensions for Organization
            : [dimensionList[0]],
          dispatch
        );
        await DataAccuracyEndPointLogic.getAllUserList(token);
      } catch (error) {
        dispatch({ type: "error", payload: { message: error } });
      } finally {
        dispatch(setTasksByTaskStructureSharedUidLoader(false));
      }
    };
    if (hasEditDataAnomalyPermission) {
      fetchDataAccuracy();
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchDataAccuracy = async () => {
      dispatch(setTasksByTaskStructureSharedUidLoader(true));
      try {
        await DataAccuracyEndPointLogic.getTasksByTaskStructureSharedUid(
          token,
          taskStructureSharedUid ?? "",
          assetSharedUid,
          dispatch
        );
        await DataAccuracyEndPointLogic.getDataAccuracyByWebsiteOrDimensionOrOrganization(
          queryId,
          token,
          type,
          type === "site" ? selectedSites : [Object.keys(siteList[0])[0]],
          fetchBy === "Dimension"
            ? selectedSites
            : fetchBy === "Organization"
            ? filteredDimensionList // Send all dimensions for Organization
            : [dimensionList[0]],
          dispatch
        );
        await DataAccuracyEndPointLogic.getAllUserList(token);
      } catch (error) {
        dispatch({ type: "error", payload: { message: error } });
      } finally {
        dispatch(setTasksByTaskStructureSharedUidLoader(false));
      }
    };
    if (hasEditDataAnomalyPermission && isSuccess) {
      fetchDataAccuracy();
    }

    // eslint-disable-next-line
  }, [isSuccess]);

  return (
    <>
      {tasksByTaskStructureSharedUidLoader ? (
        <DataAccuracyFullSkeleton />
      ) : (
        <>
          <TaskHeaderCard
            title={title}
            description={description}
            priority={priority}
            websites={websites}
            category={category}
            extraDescription={
              tasksByTaskStructureSharedUid?.[0]?.data?.[
                "meta_data:website_name"
              ]?.description ?? ""
            }
          />
          <OccurrencesTable
            filteredTasksByTaskStructureSharedUid={
              filteredTasksByTaskStructureSharedUid
            }
          />
        </>
      )}
    </>
  );
};
